import { FC } from 'react'
import TeamMemberProfileScreen from './TeamMemberProfileScreen'
import { Home } from '@lmc/ts-common'
import { useSelector } from 'react-redux'
import useFeatureFlags from 'hooks/useFeatureFlags'
import useHomeType from 'hooks/useHomeType'

export const TeamMemberProfileScreenRedirect: FC = () => {
  const home = useSelector(
    (state: { global: { home: Home } }) => state.global.home
  )

  const { hasRota } = useHomeType()

  const flags = useFeatureFlags({
    flagNames: [
      'team_member',
      'outcomes_and_goals_v2',
      'keyworkers',
      'group_access_management',
    ],
  })?.data
  const teamMemberEnabled = flags?.team_member?.enabled
  const isRosteringBetaEnabled = hasRota

  const flagsKeyworkersEnabled = flags?.keyworkers?.enabled

  const keyworkersEnabled =
    flagsKeyworkersEnabled && home?.features?.goals?.enabled

  return (
    <TeamMemberProfileScreen
      teamMemberEnabled={teamMemberEnabled}
      isRosteringBetaEnabled={isRosteringBetaEnabled}
      keyworkersEnabled={keyworkersEnabled}
    />
  )
}
